import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { ToastrService } from 'ngx-toastr';
import { error } from 'console';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { FleetService } from 'src/app/component/fleet/fleet-service/fleet.service';
import { sweetAlert } from 'src/app/utils/swal';
@Component({
  selector: 'app-vehicle-assign-modal',
  templateUrl: './vehicle-assign-modal.component.html',
  styleUrls: ['./vehicle-assign-modal.component.css']
})
export class VehicleAssignModalComponent implements OnInit {
  @Input() selectedDriver
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onVehicleAssigned = new EventEmitter<any>();

  isSelectedFleet = false;
  fleetsList: any = [];
  search:any;

  constructor(
    private fleetService: FleetService,
    private toastr: ToastrService,
    private driverService: DriversService
  ) { }

  ngOnInit() {
    if (this.selectedDriver) {
      this.fleetsList.length = 0;

      if (this.selectedDriver.isFleet) {
        this.isSelectedFleet = true;
        this.getFleetList({ driver: this.selectedDriver._id, source: this.selectedDriver.source });
      } else {
        this.isSelectedFleet = false;
        this.getFleetList({ status: 'active', source: this.selectedDriver.source });
      }
    }

  }

  updateFleet(fleet) {
    const newFleet: any = {
      fleetId: fleet._id,
      isFleet: true,
      fleet: {
        los: fleet.los,
        spaceType: fleet.spaceType,
        driverCarNumber: fleet.driverCarNumber,
        setiDecall: fleet.setiDecall
      }
    };

    this.assignFleet(newFleet, this.selectedDriver._id);
  }

  clearFleet(fleet) {
    this.assignFleet(fleet._id, this.selectedDriver._id);
    this.closeModal();
  }

  assignFleet(fleetId, driverId) {
    this.driverService.assignFleet(fleetId, driverId)
      .subscribe((data) => {
        if (data) {
          if (data.fleet) {

            let fleet = this.fleetsList.find(fleet => fleet._id === data.fleet);
            this.toastr.success(`'${fleet.driverCarNumber}' vehicle assigned to driver '${this.selectedDriver.displayName}'`, 'Alert');
            this.onVehicleAssigned.emit({isFleet: data.isFleet,fleet});

          } else {
            this.selectedDriver.isFleet = data.isFleet;
            this.toastr.error(`Vehicle taken back from driver '${this.selectedDriver.displayName}'`, 'Alert');
            this.onVehicleAssigned.emit({isFleet: false,fleet:{}});
          }
          this.closeModal();

        }
      }, (err) => {
        sweetAlert("Error", err, "error", "OK");
      });
  }

  closeModal() {
    this.onCloseModal.emit()
  }

  getFleetList(payload) {
    this.fleetService.getFleetList(payload)
      .subscribe(
        (data) => {
          if (data) {
            this.fleetsList = data;
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }
}
